import { cn } from "@/libs/cn";

interface LogStatusBadgeProps {
  success: boolean;
}

const LogStatusBadge = ({ success }: LogStatusBadgeProps) => {
  return (
    <span
      className={cn(
        "inline-flex w-fit items-center gap-1.5 rounded-full px-3 py-1 text-xs font-semibold",
        success ? "bg-green-50 text-green-700" : "bg-red-50 text-red-700",
      )}
    >
      <span className={cn("h-1.5 w-1.5 rounded-full", success ? "bg-green-600" : "bg-red-600")} />
      {success ? "Sucesso" : "Falha"}
    </span>
  );
};

export default LogStatusBadge;
